var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { api } from "./api";
import { getGameEndpoints, getManageEndpoints, getPlaceEndpoints, getScheduleEndpoints, getUploaderEndpoints, getUsersEndpoints, } from "./endpoints";
import { getTags } from "./utils";
// https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting#enhanceendpoints
var placeEndpoints = getPlaceEndpoints(api);
var scheduleEndpoints = getScheduleEndpoints(api);
var gameEndpoints = getGameEndpoints(api);
var usersEndpoints = getUsersEndpoints(api);
var uploaderEndpoints = getUploaderEndpoints();
var manageEndpoints = getManageEndpoints(api);
var endpoints = __assign(__assign(__assign(__assign(__assign(__assign({}, placeEndpoints), scheduleEndpoints), gameEndpoints), usersEndpoints), uploaderEndpoints), manageEndpoints);
export var enhancedApi = api.enhanceEndpoints({
    addTagTypes: getTags(endpoints),
    endpoints: endpoints,
});
